<!-- eslint-disable -->
<template>
  <div :class="P_customClass">
    <component :is="DV_componentType">{{P_customCss}}</component>
    <p v-show="C_isVisible" :style="textStyle">{{P_text}}</p>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../watchdog_includes/base_i10_UI_mixins"

export default {
  props: ["P_text", "P_fontSize", "P_fontWeight", "P_fontColor", "P_textAlign", 'P_customCss'],
  mixins: [bi10GridComponent],
  data () {
    return {}
  },
  computed: {
    textStyle() {
      let customCSS = {
        height: '100%',
        width: '100%',
        marginTop: '5px',
        marginLeft: '5px'
      }

      if (this.P_fontSize) customCSS["fontSize"] = this.P_fontSize
      if (this.P_fontWeight) customCSS["fontWeight"] = this.P_fontWeight
      if (this.P_fontColor) customCSS["color"] = this.P_fontColor
      if (this.P_textAlign) customCSS["textAlign"] = this.P_textAlign
      
      return customCSS;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Grid/GText.vue